/**
 * @generated SignedSource<<7fbdf675e5fdfeef9d9b56d537e22e7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type uxSimplificationFeatureToggleUXSimplificationMutation$variables = {
  enabled: boolean;
};
export type uxSimplificationFeatureToggleUXSimplificationMutation$data = {
  readonly setUxSimplificationEnabled: {
    readonly viewer: {
      readonly uxSimplificationEnabled: boolean;
    };
  } | null;
};
export type uxSimplificationFeatureToggleUXSimplificationMutation = {
  response: uxSimplificationFeatureToggleUXSimplificationMutation$data;
  variables: uxSimplificationFeatureToggleUXSimplificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "enabled",
    "variableName": "enabled"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uxSimplificationEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "uxSimplificationFeatureToggleUXSimplificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetUxSimplificationEnabled",
        "kind": "LinkedField",
        "name": "setUxSimplificationEnabled",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uxSimplificationFeatureToggleUXSimplificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetUxSimplificationEnabled",
        "kind": "LinkedField",
        "name": "setUxSimplificationEnabled",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "48e68ca64fef469e1116ca4ff20ec451",
    "id": null,
    "metadata": {},
    "name": "uxSimplificationFeatureToggleUXSimplificationMutation",
    "operationKind": "mutation",
    "text": "mutation uxSimplificationFeatureToggleUXSimplificationMutation(\n  $enabled: Boolean!\n) {\n  setUxSimplificationEnabled(enabled: $enabled) {\n    viewer {\n      uxSimplificationEnabled\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d7b463bff3021749d3a388ced1378b6";

export default node;
